import React from 'react'
import { useSelector } from 'hooks/use-redux'
import {
  getAutoTaggingTracksSent,
  getIsTrial,
} from '@disco/state-management/selectors/business'
import AutoTagging from './AutoTagging'

const AutoTaggingContainer = ({
  searchResultsCount,
  isLoading,
}: {
  searchResultsCount?: number
  isLoading?: boolean
}): React.ReactNode => {
  const user = useSelector(state => state.user)
  const isTrial = useSelector(state => getIsTrial(state))
  const autoTaggedTracksTrial =
    user.business?.private_metadata.auto_tagged_tracks_trial ?? false
  const auto_tagging_tracks_limit =
    user.business?.auto_tagging_tracks_limit ?? 0
  const { auto_tagging_tracks_sent } = useSelector(getAutoTaggingTracksSent)
  const props = {
    auto_tagging_tracks_sent,
    auto_tagging_tracks_limit,
    autoTaggedTracksTrial,
    isTrial,
    searchResultsCount: searchResultsCount || 0,
    isLoading,
  }
  return <AutoTagging {...props} />
}

export default AutoTaggingContainer
